import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DealershipsUsersService {
  constructor(private http: HttpClientService) {}

  public create(dealerships_user): Observable<any> {
    let options = {
      dealerships_user,
    };
    return this.http
      .post("/api/dealerships_users", options)
      .pipe(tap((_) => console.log("DealershipsUsersService.create: Ok.")));
  }

  public createMultiple(dealerships_user): Observable<any> {
    let options = {
      dealerships_user,
    };
    return this.http
      .post("/api/dealerships_users/multiple_dealerships_users", options)
      .pipe(tap((_) => console.log("DealershipsUsersService.createMultiple: Ok.")));
  }

  public destroy(id): Observable<any> {
    return this.http
      .delete(`/api/dealerships_users/${id}/destroy`)
      .pipe(tap((_) => console.log("DealershipsUsersService.destroy: Ok.")));
  }

  public update(id, relation: string | { relation?: string; is_key_player?: boolean }): Observable<any> {
    const options = typeof relation === "string" ? { relation } : relation;

    return this.http
      .put("/api/dealerships_users/" + id, options)
      .pipe(tap((_) => console.log("DealershipsUsersService.update: Ok.")));
  }

  public notifyAccess(id: number, options = {}): Observable<any> {
    return this.http
      .post(`/api/dealerships_users/${id}/notify_access`, options)
      .pipe(tap((_) => console.log("DealershipsUsersService.notifyAccess: Ok.")));
  }
}
